import { createAction } from '@reduxjs/toolkit'
import { AccountInfo } from 'api/v1/account'
import { Ether, TokenId } from 'types'

import { AccountTickets } from './types'

export const updateAccountInfo = createAction<AccountInfo | null>(
  'account/updateAccountInfo',
)
export const updateAccountActivatingAction = createAction<boolean>(
  'account/updateAccountActivatingAction',
)
export const updateAccountTickets = createAction<AccountTickets | undefined>(
  'account/updateAccountTickets',
)
export const logoutAction = createAction('account/logoutAction')

export const updateBalancesAction = createAction<{
  currencyId: TokenId
  available: Ether
  freeze: Ether
}>('account/updateBalancesAction')

export const updateUserToken = createAction<string>('account/updateUserToken')
